// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_tobenamed1 {
    background: var(--ColorPrimary);
    box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding: 10px;
    width: 30%;
  }

/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
    .card_tobenamed1 {
        width: auto;
      }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {

}`, "",{"version":3,"sources":["webpack://./src/components/toBeNamedCard1/toBeNamedCard1.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,UAAU;EACZ;;AAEF,2GAA2G;AAC3G;IACI;QACI,WAAW;MACb;AACN;AACA,kGAAkG;AAClG;;AAEA","sourcesContent":[".card_tobenamed1 {\n    background: var(--ColorPrimary);\n    box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    padding: 10px;\n    width: 30%;\n  }\n\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n    .card_tobenamed1 {\n        width: auto;\n      }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
